import store from "@/store";
import { SiteModel } from "@/models/SiteModel";
import { ImageModel } from "@/models/ImageModel";
import FallbackDB from "@/libraries/localStorage";
import { addMagicMethods } from "@/helpers/addMagicMethods";
import { HH, MM, getNow } from "@/helpers/date_time";
import { saveImageToLocalDB } from "@/helpers/saveImageToLocalDB";
export class ParamModel extends SiteModel {
    constructor(id = null) {
        super('params', +id);
        return addMagicMethods(this);
    }
    getTableData() {
        return store.getters['shifts/getParams'] || [];
    }
    setTableData(data) {
        store.commit('shifts/setParams', data);
        FallbackDB.save('params', data);
    }
    static onSuccessSubmit(response) {
        return super.onSuccessSubmit('ParamModel', response);
    }
    async getDataToSend() {
        const data = this.getData();
        if (+this.param.type === ParamModel.TYPE_IMAGE) {
            data.value = await this.value__byRef;
        }
        return data;
    }
    flush() {
        return super.flush('ParamModel', 'params');
    }
    __get(target, prop, receiver) {
        var _a;
        let time = '';
        let parts = [];
        switch (prop) {
            case 'value_hours':
                time = String(receiver.value);
                parts = time.split(':');
                return parts.length > 1 ? HH(parts[0]) : '00';
            case 'value_mins':
                time = String(receiver.value);
                parts = time.split(':');
                return parts.length > 1 ? MM(parts[1]) : '00';
            case 'value__byRef':
                const id = parseInt(receiver.value.replace('ref_', ''));
                const m = new ImageModel(id);
                return new Promise(async (resolver) => {
                    await m.init();
                    resolver(m.value);
                });
            case 'is_done':
                return +receiver.status === ParamModel.STATUS_DONE;
            case '_is_done':
                return (_a = target.data._is_done) !== null && _a !== void 0 ? _a : receiver.is_done;
            default:
                return super.__get(target, prop, receiver);
        }
    }
    __set(target, prop, value, receiver) {
        let hours = '00';
        let mins = '00';
        switch (prop) {
            case '_is_done':
                target.data._is_done = value;
                break;
            case 'is_done':
                receiver.status = !!value ? ParamModel.STATUS_DONE : ParamModel.STATUS_CREATED;
                if (receiver.status === ParamModel.STATUS_DONE) {
                    receiver.done_time = +getNow();
                }
                break;
            case 'value_hours':
                hours = HH(value);
                mins = receiver.value_mins;
                receiver.value = `${hours}:${mins}`;
                break;
            case 'value_mins':
                hours = receiver.value_hours;
                mins = MM(value);
                receiver.value = `${hours}:${mins}`;
                break;
            case 'value':
                if (+receiver.param.type !== ParamModel.TYPE_IMAGE) {
                    super.__set(target, prop, value, receiver);
                    break;
                }
                const genID = +getNow();
                saveImageToLocalDB(genID, value);
                super.__set(target, prop, `ref_${genID}`, receiver);
                break;
            default:
                super.__set(target, prop, value, receiver);
        }
        return true;
    }
}
ParamModel.TYPE_STRING = 10;
ParamModel.TYPE_IMAGE = 20;
ParamModel.TYPE_NUMBER = 30;
ParamModel.TYPE_DATETIME = 40;
ParamModel.TYPE_TIME = 50;
ParamModel.STATUS_CREATED = 0;
ParamModel.STATUS_DONE = 2;
window.ParamModel = ParamModel;
